import { getCrosstalkManagementRoot } from './utils';

export const environmentBase = {
    production: false,
    reportRunnerLocation: {
        hostAndPort: '',
        rootUri: '/hs-reportrunner/reportrunner/api/rr/api/',
    },
    crosstalk: {
        hostAndPort: '',
        rootUri: '/crosstalk/api',
    },
    api: './api',
    apm: {
        environment: '',
        active: false,
        host: '',
    },
    crosstalkManagementRoot: getCrosstalkManagementRoot(window.location),
};
